import { routerSelectors } from 'src/app/core/router/router.selectors'

import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { OperationInternalEvent } from './operation-internal-event'
import * as fromOperationInternalEvent from './operation-internal-event.reducer'

const state = createFeatureSelector<fromOperationInternalEvent.OperationInternalEventState>(
  fromOperationInternalEvent.FEATURE_NAME
)

const adapter = fromOperationInternalEvent.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)

const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<OperationInternalEvent>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: OperationInternalEvent[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectIdRouteParam = createSelector(
  routerSelectors.selectRouteParams,
  (params) => {
    return params && params.operationInternalEventId
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

export const operationInternalEventSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectIdRouteParam,
  selectCount
}
